import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { UserDialogComponent } from '../../../components/dialogs/user-dialog/user-dialog.component';
import {
  AlTableApi,
  AlTableColumn,
} from '../../../components/features/table/table.component';
import { User, UserService } from '../../../services/user.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
})
export class UsersComponent {
  title = '';

  @ViewChild('table') table!: AlTableApi;

  columns: AlTableColumn[] = [
    {
      key: 'name',
      title: 'Name',
    },
    {
      key: 'email', kind: 'text',
      title: 'Email',
    },
    {
      key: 'role',
      title: 'Rolle',
    },
    {
      key: 'created_at', kind: 'date',
      title: 'Erstellt am',
      sortDefault: 'asc',
      map: (i: string) => new DatePipe('de-DE', 'CET').transform(i, 'short'),
    },
  ];

  rowActions: any[] = [
    {
      key: 'edit',
      title: this.t.instant('buttons.edit'),
      icon: 'edit-outline',
    },
  ];

  globalActions = [];

  constructor(
    protected dialogService: NbDialogService,
    protected nbToastrService: NbToastrService,
    protected t: TranslateService,
    protected userService: UserService
  ) {}

  onEvent(e: { event: string; data: any }) {
    const { action, ids, rows, id, row } = e.data;

    switch (e.event) {
      case 'multiAction':
        break;
      case 'rowAction':
        if (action.key === 'edit') {
          this.editUser(row);
        }
        break;
      case 'globalAction':
        break;
      default:
        break;
    }
  }

  ngOnInit() {
    this.userService.listAllUsers().subscribe(() => {});
  }

  getAvatar(email: string): string {
    return this.userService.getAvatar(email);
  }

  get data() {
    return this.userService.users$.value;
  }

  // onImpersonate(user: User) {
  //   this.authService.impersonate(user.client_id).subscribe();
  //   // location.reload();
  // }

  // onStopImpersonate(user: User) {
  //   this.authService.stopImpersonate().subscribe();
  // }

  editUser(user: User) {
    this.dialogService.open(UserDialogComponent, {
      context: {
        data: user,
      },
    });
  }

  // deleteUser(user: User) {
  //   const confirmDialogRef = this.dialogService.open(ConfirmDialogComponent, {
  //     hasScroll: true,
  //     closeOnBackdropClick: true,
  //   });

  //   // Delete the project if the user confirms
  //   confirmDialogRef.onClose.subscribe(async (isConfirmed: boolean) => {
  //     if (isConfirmed) {
  //       this.userService.deleteUser(user.id).subscribe(() => {
  //         confirmDialogRef.close();
  //       });
  //     }
  //   });
  // }
}
